// Navigation.js
const Navigation = ({ currentIndex, totalItems, onPrevious, onNext }) => (
    <div className="d-flex justify-content-between mb-4">
      <button
        className="btn btn-primary"
        style={{ width: '250px' }}
        onClick={onPrevious}
        disabled={currentIndex === 0}
      >
        Previous
      </button>
      <span>Question {currentIndex} of {totalItems}</span>
      <button
        className="btn btn-primary"
        style={{ width: '250px' }}
        onClick={onNext}
        disabled={currentIndex === totalItems}
      >
        Next
      </button>
    </div>
  );
  
  export default Navigation;
  